import React from 'react';
var SlotRenderer = function (_a) {
    var slot = _a.slot, context = _a.context, pluginManager = _a.pluginManager;
    if (!pluginManager) {
        return null;
    }
    var components = pluginManager.getComponentsForSlot(slot);
    if (!components || components.length === 0) {
        return null;
    }
    return (React.createElement("div", { className: "asyncapi-react-plugin-slot-".concat(slot), "data-slot": slot }, components.map(function (Component, index) { return (React.createElement(React.Suspense, { key: "".concat(slot, "-").concat(index), fallback: React.createElement("div", null, "Loading plugin...") },
        React.createElement(Component, { context: context }))); })));
};
export { SlotRenderer };
//# sourceMappingURL=PluginSlotRenderer.js.map